import React from 'react';
import { Badge } from '@dev-go4ellis/go4-design-system';
import './ComparisonTable.scss';

const ROWS = [
  { label: 'Pricing model', go4: 'Flat 17.5% service fee', agency: 'Markup on hourly rate (often 40-60%)' },
  { label: 'You set the rate', go4: 'Yes', agency: 'No — agency sets it' },
  { label: 'Contracts / minimums', go4: 'None', agency: 'Usually required' },
  { label: 'Onboarding cost', go4: '$0', agency: 'Setup / placement fees' },
  { label: 'Credentialing & insurance', go4: 'Included', agency: 'Varies' },
  { label: 'Time to fill', go4: 'Same day possible', agency: 'Days to weeks' },
];

const ComparisonTable = () => (
  <section className="pl-comparison">
    <div className="pl-comparison__inner">
      <div className="pl-comparison__badge">
        <Badge variant="soft" color="info" size="sm">COMPARISON</Badge>
      </div>

      <h2 className="pl-comparison__title">Go4 vs. a staffing agency</h2>

      <div className="pl-comparison__table">
        <div className="pl-comparison__row pl-comparison__row--head">
          <div className="pl-comparison__cell pl-comparison__cell--label"></div>
          <div className="pl-comparison__cell pl-comparison__cell--go4">Go4</div>
          <div className="pl-comparison__cell pl-comparison__cell--agency">Typical agency</div>
        </div>
        {ROWS.map((row) => (
          <div key={row.label} className="pl-comparison__row">
            <div className="pl-comparison__cell pl-comparison__cell--label">{row.label}</div>
            <div className="pl-comparison__cell pl-comparison__cell--go4">{row.go4}</div>
            <div className="pl-comparison__cell pl-comparison__cell--agency">{row.agency}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ComparisonTable;
